import { FC } from "react";
import { TPrivacyTermsPage } from "@/models/common/common";
import PrivacyDetail from "@/components/privacy/PrivacyDetail";
// import { headDataPrivacy } from "../../utils/mockData/privacyMocks";
// import { headDataConditions } from "../../utils/mockData/conditionMocks";
// import HeadSection from "../common/HeadSection";
import Help from "../playWithUs/Help";

const PrivacyBody: FC<{ pathNameBody: TPrivacyTermsPage }> = ({
    pathNameBody,
}) => {
    // const headDataBody =
    //     pathNameBody === "terms" ? headDataConditions : headDataPrivacy;

    return (
        <div className="minWidth100vwFromXL">
            {/* <HeadSection
                className="mb-0"
                content={headDataBody}
                backgroundIsEmpty
            /> */}
            <PrivacyDetail pathNameDetail={pathNameBody} />
            <Help />
        </div>
    );
};

export default PrivacyBody;
